import React from 'react';

import { ContentItemWithIcon } from '@/components/sections/product-compare/compare-details/compare-summary/content-item-with-icon';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Grid } from '@/components/shared/layout/grid';
import { getValueCompareItem } from '@/components/shared/utility/add-ons';
import { ICVCompareSectionItem } from '@/contents/cv/cv-compare';
import { ILCVCompareSectionItem } from '@/contents/lcv/lcv-compare';
import { CvModelClassWithCvModel } from '@/services/contentstack/models/cv-model-class';
import { LcvModel } from '@/services/contentstack/models/lcv-model';

interface CompareSummaryProps {
  id: string;
  title: string;
  items: ILCVCompareSectionItem[] | ICVCompareSectionItem[];
  models: LcvModel[] | CvModelClassWithCvModel[];
  hasTextFromIcon?: boolean;
}
export const CompareSummary: React.FC<CompareSummaryProps> = ({
  id,
  title,
  items,
  models,
  hasTextFromIcon,
}: CompareSummaryProps) => {
  return (
    <Box
      paddingY="6"
      border="b-1"
      borderColor="gray300"
      test={{
        dataTest: 'compare_summary',
      }}
    >
      <Text
        size="text-body-1"
        font="bold"
        variant="text-red"
        css={{ py: '$space-4', '@md': { padding: '$space-4' } }}
        data-test={`${id}_title`}
      >
        {title}
      </Text>

      <Box
        paddingY="4"
        test={{
          dataTest: 'summary_body',
        }}
      >
        <Grid
          templateColumns={{ '@initial': '2', '@lg': '3' }}
          columnGap={{ '@initial': '4', '@md': '6' }}
          rowGap="6"
        >
          {items?.map((label, labelIndex) => (
            <React.Fragment key={labelIndex}>
              {models?.map((model, modelIndex) => (
                <ContentItemWithIcon
                  css={
                    modelIndex === 2
                      ? { '@maxlg': { display: 'none' } }
                      : undefined
                  }
                  key={modelIndex}
                  title={label.title}
                  value={getValueCompareItem(model, id, label.id, label.format)}
                  icon={label.icon}
                  model={model}
                  hasTextFromIcon={hasTextFromIcon}
                  test={{ dataTest: `summary_${label.id}_${modelIndex}` }}
                />
              ))}
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

CompareSummary.displayName = 'CompareSummary';
